import { render, staticRenderFns } from "./EditReferenceImages.vue?vue&type=template&id=59680e30&"
import script from "./EditReferenceImages.vue?vue&type=script&lang=ts&"
export * from "./EditReferenceImages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports